import React from "react";
import SampleComponent from "../components/SampleComponent";

const Profile = () => {
  return (
    <div>
      <SampleComponent />
      <h5>This is where components will live</h5>
    </div>
  );
};

export default Profile;
